import { createAction } from 'redux-actions'

const prefix = 'UI:'

export const SET_CAROUSEL_IMAGES = `${prefix} Set carousel images`
export const setCarouselImages = createAction(SET_CAROUSEL_IMAGES)

export const CLEAR_CAROUSEL_IMAGES = `${prefix} Clear carousel images`
export const clearCarouselImages = createAction(CLEAR_CAROUSEL_IMAGES)
